import ISelection from '@core/models/betSlip/ISelection';

export default class SelectionChange {
    public selection: ISelection;
    public newSelection?: ISelection;
    private _oldValue?: number;

    constructor(
        { selection, newSelection, oldValue }:
        { selection: ISelection; newSelection: ISelection; oldValue?: number }) {
        this.selection = selection;
        this.newSelection = newSelection;
        this._oldValue = oldValue;
    }

    get oldValue() {
        if (this._oldValue === undefined) {
            return this.selection.getOddValue() as number;
        }
        return this._oldValue;
    }

    get newValue() {
        return this.newSelection ? this.newSelection.getOddValue() as number : 0;
    }
}
